// import { PackagePresentation, MediaType } from '@mayple/types';
import axios from 'axios';
import { parse } from 'query-string';

import { createFakePpcService } from '../../fe_common/client/components/package/PackageMarketingServiceTypeInfoDialog/logic';

const convert = (str) => {
  return {
    mediaType: 'TEXT_HTML',
    contents:  str,
  };
};

const getPackageSputterUrl = (serviceType, flavor) => {
  return `https://sputter-api.mayple.com/packages/presentation/${serviceType}/${flavor}`;
};

const SPUTTER_PPC_URL = getPackageSputterUrl('PPC', 'PAID_MEDIA');

const SPUTTER_NON_PPC_PROFILES_URL = 'https://sputter-api.mayple.com/services/profiles';

const PPC_SERVICE_TYPE = 'PPC';

const DEFAULT_COST = 2000;

const DEFAULT_PPC_DISCOUNT = 10;

const DEFAULT_PPC_SPEND = 8000;

const DEFAULT_NON_PPC_DISCOUNT = 20;

export const REDIRECT_URL = 'https://welcome.mayple.com/';


/**
 * Because we call directly from sputter and not via growl, we need to make a "resolver" of our own to give a correct
 * structure of rich text.
 * @param marketingServiceTypeInfoPre
 */
export const convertRichTextStructure = (marketingServiceTypeInfoPre: Record<string, any>): Record<string, any> => {

  const marketingServiceTypeInfo = marketingServiceTypeInfoPre;

  marketingServiceTypeInfo.description = convert(marketingServiceTypeInfo.description);

  marketingServiceTypeInfo.faqs = marketingServiceTypeInfo.faqs.map(({ question, answer }) => {
    return {
      question,
      answer: convert(answer),
    };
  });

  marketingServiceTypeInfo.whatExpertsDo = marketingServiceTypeInfo.whatExpertsDo.map((w) => {
    return {
      ...w,
      content: convert(w.content),
    };
  });

  marketingServiceTypeInfo.about.forEach((about) => {
    about.contents = about.contents.map((a) => {
      return {
        ...a,
        content: convert(a.content),
      };
    });
  });

  return marketingServiceTypeInfo;

};

async function getPpcPackageData() {

  try {

    const response = await axios.get(SPUTTER_PPC_URL);

    const marketingServiceTypeInfo = convertRichTextStructure(response.data);

    return createFakePpcService(
      'tieredPlan20210401',
      DEFAULT_COST,
      DEFAULT_PPC_SPEND,
      DEFAULT_PPC_DISCOUNT,
      [
        { skillType: 'FACEBOOK_ADS', budgetForSkillType: 5000 },
        { skillType: 'GOOGLE_ADS', budgetForSkillType: 5000 },
      ],
      marketingServiceTypeInfo,
    );

  } catch (e) {

    console.error(e);

    return null;

  }

}


async function getNonPpcPackagesData(serviceType, flavor) {

  try {

    const servicesProfilesResponse = await axios.get(SPUTTER_NON_PPC_PROFILES_URL);
    const serviceTypeInfoResponse = await axios.get(getPackageSputterUrl(serviceType, flavor));
    const marketingServiceTypeInfo = convertRichTextStructure(serviceTypeInfoResponse.data);

    const serviceFound = servicesProfilesResponse.data.find((service) => {
      return serviceType === service.serviceType;
    });

    const packageFound = serviceFound.packages.find((p) => {
      return flavor === p.flavor;
    });

    packageFound.description = convert(packageFound.description);
    packageFound.marketingServiceTypeInfo = marketingServiceTypeInfo;
    packageFound.discount = DEFAULT_NON_PPC_DISCOUNT;
    packageFound.uuid = Date.now() + Math.random().toString(36);

    return packageFound;

  } catch (e) {

    console.error(e);

    return null;

  }

}

/**
 * Will load the data based on the query parameters.
 * either a PPC or NON PPC service type, and will fix the data structure accordingly.
 */
export const getPackageDataFromCms = async () => {

  const queryParams = parse(window.location.search);
  const { serviceType, flavor } = queryParams;
  let result;

  if (!serviceType || !flavor) {
    return null;
  }

  if (serviceType === PPC_SERVICE_TYPE) {

    result = await getPpcPackageData();

  } else {

    result = await getNonPpcPackagesData(serviceType, flavor);

  }

  return result || null;

};
